import { ArrowRight, ArrowDown, Check } from "lucide-react";
import { livePlatforms } from "../../lib/platforms";
import { Mark } from "../Logo";

const LINES = [
  ["Copy paper × 10", "$420.00"],
  ["Toner cartridge × 4", "$780.00"],
  ["Sales tax", "$84.00"],
];

function Lines() {
  return (
    <div className="mt-3 space-y-1.5">
      {LINES.map(([d, a]) => (
        <div key={d} className="flex justify-between gap-3 text-[11px] text-neutral-600">
          <span className="truncate">{d}</span><span className="font-mono">{a}</span>
        </div>
      ))}
      <div className="flex justify-between border-t border-neutral-200 pt-2 mt-2 text-xs font-semibold text-neutral-900">
        <span>Total</span><span className="font-mono">$1,284.00</span>
      </div>
    </div>
  );
}

function Card({ label, number, title, gl, done, testid }) {
  return (
    <div className={`bg-white border p-4 w-full sm:w-[12.5rem] ${done
          ? "border-emerald-600 shadow-[5px_5px_0_0_#059669]"
          : "border-neutral-900 shadow-[5px_5px_0_0_#0a0a0a]"}`} data-testid={testid}>
      <div className="flex items-center justify-between label-mini">
        <span className={`flex items-center gap-1 whitespace-nowrap ${done ? "text-emerald-700" : ""}`}>
          {done && <Check size={11} strokeWidth={3} />}{label}
        </span>
        {number && <span className="whitespace-nowrap">{number}</span>}
      </div>
      <div className="font-display font-bold text-base mt-2 leading-tight">{title}</div>
      <Lines />
      <div className="mt-3 inline-block border border-neutral-300 px-2 py-0.5 text-[10px] uppercase tracking-widest text-neutral-600">
        {gl}
      </div>
    </div>
  );
}

function Connector() {
  return (
    <div className="flex items-center justify-center text-neutral-400 py-1 sm:py-0" aria-hidden="true">
      <ArrowDown size={18} className="sm:hidden" />
      <ArrowRight size={18} className="hidden sm:block" />
    </div>
  );
}

export default function HeroGraphic() {
  return (
    <div className="relative" data-testid="hero-graphic" role="img"
         aria-label="A vendor invoice from Xero passes through Lingua Franca and becomes a bill in QuickBooks Online">
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-2">
        <Card label="invoice" number="#1042" title="Acme Supply Co." gl="from Xero" testid="hero-invoice-card" />
        <Connector />
        <div className="flex flex-col items-center gap-2 shrink-0">
          <div className="lf-pulse-ring w-14 h-14 bg-neutral-900 text-white flex items-center justify-center">
            <Mark dark size={32} testid="hero-mark" />
          </div>
        </div>
        <Connector />
        <Card label="bill created" title="Acme Supply Co." gl="into QuickBooks Online" done
              testid="hero-bill-card" />
      </div>
      <div className="mt-8 flex flex-wrap justify-center gap-2 text-[10px] uppercase tracking-widest text-neutral-500">
        {livePlatforms().map((p) => (
          <span key={p.key} className="border border-dashed border-neutral-300 px-2 py-0.5">{p.short}</span>
        ))}
      </div>
    </div>
  );
}
